import { render, staticRenderFns } from "./League.vue?vue&type=template&id=3122b844&scoped=true&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"
import style0 from "./League.vue?vue&type=style&index=0&id=3122b844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122b844",
  null
  
)

export default component.exports